(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Select all tabs and tab contents
    var tabs = document.querySelectorAll('.custom-tab');
    var tabContents = document.querySelectorAll('.custom__tab-content');

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var contentId = this.dataset.contentId;
        var content = document.getElementById(contentId);
        // Remove 'active' class from all tabs and contents
        tabContents.forEach(function(content) {
          content.classList.remove('active');
        });
        tabs.forEach(function(tab) {
          tab.classList.remove('active');
        });
        // Add 'active' class to the clicked tab and its content
        this.classList.add('active');
        content.classList.add('active');
      });
    });
  });

  const accordionItemHeaders = document.querySelectorAll(".accordion-item-header");

  accordionItemHeaders.forEach(accordionItemHeader => {
    accordionItemHeader.addEventListener("click", event => {
      // Uncomment in case you only want to allow for the display of only one collapsed item at a time!
      const currentlyActiveAccordionItemHeader = document.querySelector(".accordion-item-header.active");
      if(currentlyActiveAccordionItemHeader && currentlyActiveAccordionItemHeader!==accordionItemHeader) {
        currentlyActiveAccordionItemHeader.classList.toggle("active");
        currentlyActiveAccordionItemHeader.nextElementSibling.style.maxHeight = 0;
      }

      accordionItemHeader.classList.toggle("active");
      const accordionItemBody = accordionItemHeader.nextElementSibling;
      if(accordionItemHeader.classList.contains("active")) {
        accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px";
      }
      else {
        accordionItemBody.style.maxHeight = 0;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["policies"] && !Shopify.designMode) return;
  try {
    
  const accordionItemHeaders = document.querySelectorAll('.accordion-item-header');

  accordionItemHeaders.forEach((accordionItemHeader) => {
    accordionItemHeader.addEventListener('click', (event) => {
      // Uncomment in case you only want to allow for the display of only one collapsed item at a time!
      const currentlyActiveAccordionItemHeader = document.querySelector('.accordion-item-header.active');
      if (currentlyActiveAccordionItemHeader && currentlyActiveAccordionItemHeader !== accordionItemHeader) {
        currentlyActiveAccordionItemHeader.classList.toggle('active');
        currentlyActiveAccordionItemHeader.nextElementSibling.style.maxHeight = 0;
      }
      accordionItemHeader.classList.toggle('active');
      const accordionItemBody = accordionItemHeader.nextElementSibling;
      if (accordionItemHeader.classList.contains('active')) {
        accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + 'px';
      } else {
        accordionItemBody.style.maxHeight = 0;
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
